<template>
  <div class="container mt-5">
    <h1>Configuração de valores de índice</h1>
    <SuccessFadeAlert ref="successFadeAlert" :msg="alert.success" />
    <RevisionIndiceValueCreate :model.sync="model" />
    <b-button @click="save" size="sm" :disabled="isSaving">
      {{ isSaving ? $t("Salvando") : $t("geral.save") }}
    </b-button>
  </div>
</template>

<script>
import RevisionIndiceValueCreate from "../../../components_rms/vehicle/RevisionIndiceValueCreate.vue";
import SuccessFadeAlert from "../../../components/SuccessFadeAlert.vue";

export default {
  components: {
    RevisionIndiceValueCreate,
    SuccessFadeAlert
  },
  data() {
    return {
      model: {
        id: 0,
        companyId: 0,
        kmGreen: 0,
        kmYellow: 0,
        kmRed: 0,
        horimeterGreen: 0,
        horimeterYellow: 0,
        horimeterRed: 0,
        daysGreen: 0,
        daysYellow: 0,
        daysRed: 0
      },
      alert: {
        success: ""
      },
      isSaving: false
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      console.log("loadData");
      this.$apiVehicle.get("/GetRevisionsIndiceValues/").then(response => {
        this.model.companyId = response.data.companyId;
        this.model.kmGreen = response.data.kmGreen;
        this.model.kmYellow = response.data.kmYellow;
        this.model.kmRed = response.data.kmRed;
        this.model.horimeterGreen = response.data.horimeterGreen;
        this.model.horimeterYellow = response.data.horimeterYellow;
        this.model.horimeterRed = response.data.horimeterRed;
        this.model.daysGreen = response.data.daysGreen;
        this.model.daysYellow = response.data.daysYellow;
        this.model.daysRed = response.data.daysRed;
      });
    },
    save() {
      this.isSaving = true;
      this.$apiVehicle
        .post("/SaveRevisionIndiceValues/", this.model)
        .then(response => {
          if (response.status === 200) {
            this.alert.success = "Valores de índice salvos com sucesso!";
            this.$refs.successFadeAlert.show();
          }
        })
        .catch(error => {
          console.error("Erro ao salvar os valores de índice:", error);
        })
        .finally(() => {
          this.isSaving = false;
        });
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 600px;
}
</style>
